<template>
  <a-space wrap :size="32">
    <a-avatar :class="['custom-avatar', $props.class]"
              :size="resolvedSize"
              :shape="shape"
              :style="{
                 width: typeof size === 'number' ? `${size}px` : undefined,
                height: typeof size === 'number' ? `${size}px` : undefined,
                backgroundColor: src ? 'inherit' : 'var(--PRIMARY-COLOR)'
              }">
      <template #icon>
            <span v-if="!src">
                {{ alt ? alt[0] : "-" }}
            </span>
        <a v-else>
          <a-image :class="imgClass" :src="src"/>
        </a>
      </template>
    </a-avatar>
  </a-space>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  src: String,
  alt: String,
  class: null,
  imgClass: null,
  shape: String,
  size: [Number, String],

});

const resolvedSize = computed(() => {
  if (typeof props.size === "number") return props.size;
  if (props.size === "large" || props.size === "small") return props.size;
  return "large"; // fallback
});

</script>

<style scoped>
/* Override ant default avatar sizing */
:deep(.custom-avatar.ant-avatar) {
  display: inline-flex;
  justify-content: center;
  align-items: center;
 /* makes it square with soft edges */
  overflow: hidden !important;
}

/* Let the custom numeric size take effect */
:deep(.custom-avatar.ant-avatar-square) {
  width: auto !important;
  height: auto !important;
}

/* Make image fill perfectly */
:deep(.ant-image-img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
